import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

Sentry.init({
  // Only active in production builds. Set SENTRY_ENABLED=true in staging if needed.
  enabled: environment.production,
  dsn: "https://19c3c7bd778e512f48b36109f6be45b0@o4510971658829824.ingest.us.sentry.io/4510971664465920",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing — capture every transaction in dev; sample 20% in production to limit overhead.
  tracesSampleRate: environment.production ? 0.2 : 1.0,
  // Propagate the sentry-trace header to our own API only (avoids leaking to third-party calls).
  // Covers localhost in dev and the relative /api path in production.
  tracePropagationTargets: ["localhost", /^\/api/],
  // Session Replay — low rate for normal sessions, always capture on errors.
  replaysSessionSampleRate: environment.production ? 0.1 : 1.0,
  replaysOnErrorSampleRate: 1.0,
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => Sentry.captureException(err));
